import angular from 'angular';
import commissionTable from './commissionTable';
import './style.scss';

export default angular
  .module('commission.components.commissionTable', [])
  .component('commissionTable', commissionTable).name;
